import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicColor } from "../Utils/constants";
import { useState } from "react";
import ScrollingText from "../Component/Dynamic/ScrollingText";
import RegHome from "../Component/RegHome2024";
import { PhoneIcon } from "../Utils/SVGs";
import WelcomeScr from "./WelcomeScr";

function MainScr() {
  const { t, i18n } = useTranslation();
  const [showReg, setShowReg] = useState(false);

  return (
    <>
      <ScrollingText
        text={t("ScrollingTxt")}
        textColor={BasicColor}
        backgroundColor="white"
        speed={10} // Adjust speed as desired
      />

      <br />

      <Button
        variant="danger"
        onClick={() => {
          setShowReg(!showReg);
        }}
      >
        {showReg ? t("CancelRegistration") : t("Registration")}
      </Button>
      <Button
        variant="success"
        dir="ltr"
        style={{
          margin: "10px",
          fontWeight: "bold",
        }}
        onClick={() => {
          const telHref = `tel:${"+201110115999"}`;
          window.location.href = telHref;
        }}
      >
        {"  "}
        {PhoneIcon("white", 20)}
        {"  "}
        +201110115999
      </Button>

      {/* {showReg && <ClinicAppointmentReg />} */}
      {showReg && <RegHome />}
      {!showReg && <WelcomeScr />}
    </>
  );
}

export default MainScr;
